import React from "react"

class BillingPoliciesDataType extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    if ( this.props.row.billing_policies && this.props.row.billing_policies.length > 0) {

      var billingPolicies = [];

      for (let step = 0; step < this.props.row.billing_policies.length; step++) {
        if (step < 4) {
          billingPolicies.push(<li key={this.props.row.billing_policies[step].id}>{this.props.row.billing_policies[step].name}</li>);
        } else if (step === 4) {
          billingPolicies.push(<li key='additional-room-types'><i>... {` ${I18n.t('more')}`}</i></li>);
        };
      };


      return(
        <ul style={{marginBottom: 0}}>{billingPolicies}</ul>
      )
    } else {
      return null;
    }
  }
}

export default BillingPoliciesDataType